//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class BaseEntity {
    identifier;
    createdOn;
    modifiedOn;
    constructor() {
        this.identifier = "";
        this.createdOn = null;
        this.modifiedOn = null;
    }
}
export class CentroDiCosto extends BaseEntity {
    nomeAgenzia;
    businessUnit;
    codice;
    constructor() {
        super();
        this.nomeAgenzia = "";
        this.businessUnit = "";
        this.codice = "";
    }
}
export class JdeImportError extends BaseEntity {
    numeroProposta;
    processo;
    exceptionJson;
    dismissedOn;
    constructor() {
        super();
        this.numeroProposta = "";
        this.processo = "";
        this.exceptionJson = "";
        this.dismissedOn = null;
    }
}
export class LoginResponse {
    token;
    role;
    constructor() {
        this.token = "";
        this.role = "";
    }
}
export class MovimentoStatResponse {
    totalRicaviCount;
    totalIncassiCount;
    totalRicaviAmount;
    totalIncassiAmount;
    constructor() {
        this.totalRicaviCount = null;
        this.totalIncassiCount = null;
        this.totalRicaviAmount = null;
        this.totalIncassiAmount = null;
    }
}
export class GetMovimentiFilterVm {
    fromDate;
    toDate;
    userIds;
    groupName;
    constructor() {
        this.fromDate = null;
        this.toDate = null;
        this.userIds = [];
        this.groupName = "";
    }
}
export class ForecastRowResponse {
    businessUnit;
    sede;
    pertinenze;
    unitaTotali;
    unitaResidue;
    unitaVendute;
    numeroLead;
    numeroAppuntamenti;
    proposte;
    proposteInviate;
    proposteIncerte;
    proposteIncerteCondizioneSospensiva;
    valoreComplessivoIncerte;
    valoreComplessivoProposteIncerteCondizioneSospensiva;
    proposteCerte;
    proposteIncassate;
    proposteRifiutate;
    valoreProposteAccettate;
    feeMedia;
    percFeePA;
    percFeePV;
    totaleFee;
    constructor() {
        this.businessUnit = "";
        this.sede = "";
        this.pertinenze = null;
        this.unitaTotali = "";
        this.unitaResidue = "";
        this.unitaVendute = "";
        this.numeroLead = "";
        this.numeroAppuntamenti = "";
        this.proposte = "";
        this.proposteInviate = "";
        this.proposteIncerte = "";
        this.proposteIncerteCondizioneSospensiva = "";
        this.valoreComplessivoIncerte = null;
        this.valoreComplessivoProposteIncerteCondizioneSospensiva = null;
        this.proposteCerte = "";
        this.proposteIncassate = "";
        this.proposteRifiutate = "";
        this.valoreProposteAccettate = "";
        this.feeMedia = "";
        this.percFeePA = "";
        this.percFeePV = "";
        this.totaleFee = "";
    }
}
export class GetForecastRowFilterVm {
    userIds;
    businessUnit;
    sede;
    constructor() {
        this.userIds = [];
        this.businessUnit = "";
        this.sede = "";
    }
}
export class NameIdentifier {
    name;
    identifier;
    constructor() {
        this.name = "";
        this.identifier = "";
    }
}
export class Movimento extends BaseEntity {
    propostaIdentifier;
    idImmobile;
    idTrattativa;
    idUnivocoImmobile;
    tipoMovimento;
    data;
    importo;
    centroDiCosto;
    acquirenteVenditore;
    constructor() {
        super();
        this.propostaIdentifier = "";
        this.idImmobile = null;
        this.idTrattativa = "";
        this.idUnivocoImmobile = null;
        this.tipoMovimento = "";
        this.data = null;
        this.importo = null;
        this.centroDiCosto = "";
        this.acquirenteVenditore = "";
    }
}
export class OnOfficePagedResponseOfOnOfficeUserResponse {
    page;
    total;
    data;
    constructor() {
        this.page = null;
        this.total = null;
        this.data = [];
    }
}
export class OnOfficeUserResponse {
    idNumber;
    nome;
    cognome;
    username;
    email;
    constructor() {
        this.idNumber = "";
        this.nome = "";
        this.cognome = "";
        this.username = "";
        this.email = "";
    }
}
export class GetGroupsResponse {
    onOfficeGroupId;
    onOfficeName;
    groupType;
    onOfficeUserIds;
    constructor() {
        this.onOfficeGroupId = null;
        this.onOfficeName = "";
        this.groupType = "";
        this.onOfficeUserIds = [];
    }
}
export class PermessiInvio extends BaseEntity {
    userId;
    nome;
    cognome;
    canSeeButton;
    canModifyProposteInErrore;
    constructor() {
        super();
        this.userId = "";
        this.nome = "";
        this.cognome = "";
        this.canSeeButton = false;
        this.canModifyProposteInErrore = false;
    }
}
export class Proposta extends BaseEntity {
    isSendable;
    immobili;
    generale;
    date;
    provvigioniAcquirente;
    provvigioniVenditore;
    pagamenti;
    notaNonInviata;
    errors;
    activitiesCalculatedOn;
    constructor() {
        super();
        this.isSendable = null;
        this.immobili = [];
        this.generale = new Generale();
        this.date = new DateProposta();
        this.provvigioniAcquirente = new ProvvigioniProposta();
        this.provvigioniVenditore = new ProvvigioniProposta();
        this.pagamenti = new Pagamenti();
        this.notaNonInviata = "";
        this.errors = [];
        this.activitiesCalculatedOn = null;
    }
}
export class Immobile {
    idImmobile;
    numero_Immobile;
    centroDiCosto;
    assetClass;
    tipoDiBusiness;
    sede;
    tipologiaDiCommercializzazione;
    citta;
    indirizzo;
    numeroCivico;
    metriQuadri;
    constructor() {
        this.idImmobile = null;
        this.numero_Immobile = "";
        this.centroDiCosto = "";
        this.assetClass = "";
        this.tipoDiBusiness = "";
        this.sede = "";
        this.tipologiaDiCommercializzazione = "";
        this.citta = "";
        this.indirizzo = "";
        this.numeroCivico = "";
        this.metriQuadri = "";
    }
}
export class Generale {
    venditori;
    acquirenti;
    conduttori;
    idTrattativa;
    statoTrattativa;
    askingPrice;
    closingPrice;
    prezzoOfferta;
    prezzoVendita;
    condizioneSospensiva;
    esito;
    constructor() {
        this.venditori = [];
        this.acquirenti = [];
        this.conduttori = [];
        this.idTrattativa = "";
        this.statoTrattativa = "";
        this.askingPrice = null;
        this.closingPrice = null;
        this.prezzoOfferta = null;
        this.prezzoVendita = null;
        this.condizioneSospensiva = false;
        this.esito = "";
    }
}
export class AnagraficaUtenteForExport {
    matricola;
    ragione_Sociale;
    partita_Iva;
    codice_Fiscale;
    lingua;
    categoria_di_Contatto;
    indirizzo;
    cap;
    citta;
    paese;
    provincia;
    codice_SDI;
    pec;
    email;
    numero_Telefono;
    constructor() {
        this.matricola = "";
        this.ragione_Sociale = "";
        this.partita_Iva = "";
        this.codice_Fiscale = "";
        this.lingua = "";
        this.categoria_di_Contatto = "";
        this.indirizzo = "";
        this.cap = "";
        this.citta = "";
        this.paese = "";
        this.provincia = "";
        this.codice_SDI = "";
        this.pec = "";
        this.email = "";
        this.numero_Telefono = "";
    }
}
export class AnagraficaUtente extends AnagraficaUtenteForExport {
    userId;
    addressId;
    iD_Univoco;
    nome;
    cognome;
    centro_Costo;
    constructor() {
        super();
        this.userId = null;
        this.addressId = null;
        this.iD_Univoco = null;
        this.nome = "";
        this.cognome = "";
        this.centro_Costo = "";
    }
}
export class DateProposta {
    dataProposta;
    dataAccettazione;
    dataScadenza;
    dataInvio;
    dataNotifica;
    dataRifiuto;
    dataRicavo;
    dataCertaCommerciale;
    dataPreliminare;
    dataIncassoAcquirente;
    dataIncassoVenditore;
    dataEmissioneFatturaAcquirente;
    dataEmissioneFatturaVenditore;
    constructor() {
        this.dataProposta = null;
        this.dataAccettazione = null;
        this.dataScadenza = null;
        this.dataInvio = null;
        this.dataNotifica = null;
        this.dataRifiuto = null;
        this.dataRicavo = null;
        this.dataCertaCommerciale = null;
        this.dataPreliminare = null;
        this.dataIncassoAcquirente = null;
        this.dataIncassoVenditore = null;
        this.dataEmissioneFatturaAcquirente = null;
        this.dataEmissioneFatturaVenditore = null;
    }
}
export class ProvvigioniProposta {
    percentualeSuImporto;
    totaleProvvigione;
    useImportoForfettario;
    importoForfettario;
    datiProvvigione;
    fattureCollegate;
    constructor() {
        this.percentualeSuImporto = null;
        this.totaleProvvigione = null;
        this.useImportoForfettario = false;
        this.importoForfettario = null;
        this.datiProvvigione = [];
        this.fattureCollegate = "";
    }
}
export class DatiProvvigione {
    user;
    isSegnalatore;
    percProvvigione;
    valoreProvvigione;
    constructor() {
        this.user = new AnagraficaUtente();
        this.isSegnalatore = false;
        this.percProvvigione = null;
        this.valoreProvvigione = null;
    }
}
export class Pagamenti {
    tipoPagamento;
    modalitaPagamento;
    dataPagamento;
    importo;
    banca;
    numeroAssegno;
    importoAssegno;
    nota;
    constructor() {
        this.tipoPagamento = "";
        this.modalitaPagamento = "";
        this.dataPagamento = null;
        this.importo = null;
        this.banca = "";
        this.numeroAssegno = "";
        this.importoAssegno = null;
        this.nota = "";
    }
}
export class PropostaErrorRow {
    date;
    description;
    constructor() {
        this.date = null;
        this.description = "";
    }
}
export class TablePagedResultOfPropostaForTable {
    data;
    count;
    pageNumber;
    perPage;
    constructor() {
        this.data = [];
        this.count = null;
        this.pageNumber = null;
        this.perPage = null;
    }
}
export class PropostaForTable extends Proposta {
    percentualeIncassoAcquirenti;
    percentualeIncassoVenditori;
    constructor() {
        super();
        this.percentualeIncassoAcquirenti = null;
        this.percentualeIncassoVenditori = null;
    }
}
export class BasePagedRequest {
    pageNumber;
    perPage;
    sortBy;
    constructor() {
        this.pageNumber = null;
        this.perPage = null;
        this.sortBy = new SortByParameter();
    }
}
export class GetProposteFilterVm extends BasePagedRequest {
    createdOnFrom;
    createdOnTo;
    dataPropostaFrom;
    dataPropostaTo;
    idTrattativa;
    centroDiCosto;
    numeriImmobile;
    indirizzi;
    statoTrattativa;
    dataInvio;
    prezzoOfferta;
    acquirenti;
    venditori;
    businessUnit;
    estateId;
    userIds;
    groupName;
    constructor() {
        super();
        this.createdOnFrom = null;
        this.createdOnTo = null;
        this.dataPropostaFrom = null;
        this.dataPropostaTo = null;
        this.idTrattativa = "";
        this.centroDiCosto = "";
        this.numeriImmobile = "";
        this.indirizzi = "";
        this.statoTrattativa = "";
        this.dataInvio = null;
        this.prezzoOfferta = "";
        this.acquirenti = "";
        this.venditori = "";
        this.businessUnit = "";
        this.estateId = null;
        this.userIds = [];
        this.groupName = "";
    }
}
export class SortByParameter {
    propertyName;
    ascending;
    constructor() {
        this.propertyName = "";
        this.ascending = false;
    }
}
export class OnOfficePagedResponseOfOnOfficePagedEstateRow {
    page;
    total;
    data;
    constructor() {
        this.page = null;
        this.total = null;
        this.data = [];
    }
}
export class OnOfficePagedEstateRow {
    id;
    citta;
    centroDiCosto;
    numeroImmobile;
    indirizzo;
    numeroCivico;
    zona;
    assetClass;
    superficieCommerciale;
    createdOn;
    constructor() {
        this.id = "";
        this.citta = "";
        this.centroDiCosto = "";
        this.numeroImmobile = "";
        this.indirizzo = "";
        this.numeroCivico = "";
        this.zona = "";
        this.assetClass = "";
        this.superficieCommerciale = "";
        this.createdOn = "";
    }
}
export class ExportForecastSearchEstateVm {
    userIds;
    citta;
    centroDiCosto;
    numeroImmobile;
    stammobjektOnly;
    indirizzo;
    zona;
    assetClass;
    superficieCommercialeMin;
    superficieCommercialeMax;
    createdFrom;
    createdTo;
    constructor() {
        this.userIds = [];
        this.citta = "";
        this.centroDiCosto = "";
        this.numeroImmobile = "";
        this.stammobjektOnly = false;
        this.indirizzo = "";
        this.zona = "";
        this.assetClass = "";
        this.superficieCommercialeMin = "";
        this.superficieCommercialeMax = "";
        this.createdFrom = "";
        this.createdTo = "";
    }
}
export class SearchEstateVm extends ExportForecastSearchEstateVm {
    page;
    count;
    constructor() {
        super();
        this.page = null;
        this.count = null;
    }
}
export class OnOfficePagedResponseOfAnagraficaUtente {
    page;
    total;
    data;
    constructor() {
        this.page = null;
        this.total = null;
        this.data = [];
    }
}
export class ExportForecastRequestVm {
    estateIds;
    allFromSearchVm;
    searchVm;
    startDate;
    endDate;
    constructor() {
        this.estateIds = [];
        this.allFromSearchVm = false;
        this.searchVm = new ExportForecastSearchEstateVm();
        this.startDate = null;
        this.endDate = null;
    }
}
export class KeyValuePairOfStringAndString {
    key;
    value;
    constructor() {
        this.key = "";
        this.value = "";
    }
}
